/**
 * Expose all endpoints for 'reports'.
 */
export const reportsApiMock = () => ({
  // descarga un archivo
  downloadReport: (reportName, filters) =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({});
      }, 1000);
    })
});

export const reportsApi = api => ({
  // el api recibe el nombre del reporte en el path y como query parameters los filtros
  // la lista de nombres de reporte soportados viene en el ca,po 'reports' de account
  downloadReport: ({ reportName, filters }) => { 
    return api.get(
      "reports/" + reportName,
      { ...filters },
      {
        responseType: "blob"
      }
    );
  }
});



// WEBPACK FOOTER //
// ./src/services/api/reportsApi.js